import { Achievement, AchievementService } from '../../../shared/services/achievement.service';
import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { StatisticService } from '../../../shared/services/statistic.service';
import * as moment from 'moment';
import { InfoPopupComponent } from '../info-popup/info-popup.component';
import { UserService } from '../../../shared/services/user.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { forEach } from 'lodash';

@Component({
  selector: 'app-achievement-ranking',
  styleUrls: ['ranking-achievement.component.scss'],
  templateUrl: 'ranking-achievement.component.html',
})
export class RankingAchievementComponent implements AfterViewInit {
  displayedColumns: string[] = ['position', 'name', 'badges', 'punkte'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  date: any;

  aliasForm = new FormGroup({
    alias: new FormControl('', [Validators.maxLength(30)]),
  });

  @ViewChild(InfoPopupComponent) aliasPopup: InfoPopupComponent;

  constructor(
    private stats: StatisticService,
    private userService: UserService,
    private achievementService: AchievementService
  ) {
    this.date = moment();
    this.loadLeaderboard();
  }

  ngAfterViewInit() {
    this.userService.currentUser.subscribe((user) => {
      if (!user) {
        return;
      }

      const alias = user.alias;

      if (!alias) {
        this.aliasPopup.show();
      }
    });
  }

  async loadLeaderboard(month?: number, year?: number) {
    try {
      const data = await this.stats.getCompanyLeaderboard(month, year);

      // order from highest to lowest points
      data.sort((a, b) => b.points - a.points);

      for (let index = 0; index < data.length; index++) {
        data[index].position = index + 1;
      }

      const promises = data.map(async (item) => {
        const achievements = await this.achievementService.getAchievementsForLeaderboard(item._id);
        let displayCount = achievements.length - 3;
        const topThree = achievements.slice(0, 3);

        if (displayCount < 0) {
          displayCount = 0;
        }

        item.badges = { achievement: topThree, count: displayCount };
      });

      // Wait for all the promises to resolve before proceeding
      await Promise.all(promises);

      this.dataSource = new MatTableDataSource(data);
    } catch (error) {
      console.error('Error loading leaderboard:', error);
    }
  }

  getCurrentAchievementLevel(achievement: Achievement): string {
    const progress = achievement.progress;
    const levels = achievement.levels;
    const levelsArr = ['green', 'bronze', 'silber', 'gold'];

    if (levels) {
      let progressToNextLevel = progress;
      let currentLevel = 'unlocked';

      for (const levelName of levelsArr) {
        const level = levels[levelName];
        if (progressToNextLevel >= level) {
          currentLevel = levelName;
          progressToNextLevel -= level;
        } else {
          break; // Stop checking once the current level is found
        }
      }

      return currentLevel;
    } else if (achievement.finishedAt || (!achievement.hasLevels && achievement.progress === 1)) {
      return 'gold';
    } else {
      return 'unlocked';
    }
  }

  nextMonth() {
    this.date.add(1, 'M');
    this.loadLeaderboard(this.date.month() + 1, this.date.year());
  }

  prevMonth() {
    this.date.subtract(1, 'M');
    this.loadLeaderboard(this.date.month() + 1, this.date.year());
  }

  saveAlias(anonym?: boolean) {
    if (!anonym && !this.aliasForm.valid) {
      return;
    }

    const alias = anonym ? 'anonym' : this.aliasForm.value.alias ? this.aliasForm.value.alias : 'anonym';
    this.userService
      .updateUser({
        alias: alias,
      })
      .then(() => this.userService.getThisUser());

    this.dataSource.data.find((item) => item.isRequester === true).alias = alias;
    this.aliasPopup.close();
  }
}

interface Badges {
  achievement: Achievement[];
  count: number;
}

export interface Element {
  alias: string;
  position: number;
  points: number;
  isRequester: boolean;
  badges: Badges;
}

const ELEMENT_DATA: Element[] = [
  { position: 0, alias: '...', points: 0, isRequester: false, badges: { achievement: [], count: 0 } },
  { position: 1, alias: '...', points: 0, isRequester: false, badges: { achievement: [], count: 0 } },
  { position: 2, alias: '...', points: 0, isRequester: false, badges: { achievement: [], count: 0 } },
  { position: 3, alias: '...', points: 0, isRequester: false, badges: { achievement: [], count: 0 } },
  { position: 4, alias: '...', points: 0, isRequester: false, badges: { achievement: [], count: 0 } },
  { position: 5, alias: '...', points: 0, isRequester: false, badges: { achievement: [], count: 0 } },
];



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/ranking-achievements/ranking-achievement.component.ts